import _ from 'lodash';
import {
  startFlow,
  stopFlow,
  addFlowData,
  removeFlowData,
  resetFlow,
  changeFlowStep,
} from '../actions/flows';

const isCorrectFlow = (flowId, reducerFlowId) => flowId === reducerFlowId;

export const createIsActive =
  (reducerFlowId) =>
  (state = false, { type, payload = {} }) => {
    const flowId = _.get(payload, 'flowId');
    switch (type) {
      case startFlow.type:
        return isCorrectFlow(flowId, reducerFlowId);
      case stopFlow.type:
        return false;
      default:
        return state;
    }
  };

export const createFlowData =
  (reducerFlowId) =>
  (state = {}, { type, payload = {} }) => {
    const flowId = _.get(payload, 'flowId');

    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case startFlow.type: {
        const resumeFlow = _.get(payload, 'options.resumeFlow', false);
        const existingData = resumeFlow ? state : {};
        const initialData = _.get(payload, 'options.initialData', {});
        return {
          ...existingData,
          ...initialData,
        };
      }
      case addFlowData.type: {
        const { data } = payload;
        return { ...state, ...data };
      }
      case removeFlowData.type: {
        const { key } = payload;

        return _.omit(state, key);
      }
      case resetFlow.type:
        return {};

      default:
        return state;
    }
  };

export const createStoppedReason =
  (reducerFlowId) =>
  (state = null, { type, payload = {} }) => {
    const flowId = _.get(payload, 'flowId');
    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case startFlow.type:
        return null;
      case stopFlow.type:
        return payload.reason;
      case resetFlow.type:
        return null;
      default:
        return state;
    }
  };

export const createStep =
  (reducerFlowId) =>
  (state = null, { type, payload = {} }) => {
    const flowId = _.get(payload, 'flowId');
    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case stopFlow.type:
        return null;
      case changeFlowStep.type: {
        const { step, direction } = payload;
        return step ? { step, direction } : null;
      }
      default:
        return state;
    }
  };

export const createFlowConfig =
  (reducerFlowId) =>
  (state = null, { type, payload = {} }) => {
    const flowId = _.get(payload, 'flowId');
    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case stopFlow.type:
      case resetFlow.type:
        return null;
      case startFlow.type:
        return payload.options;
      default:
        return state;
    }
  };

const createFlowReducer = (reducerFlowId) => ({
  isActive: createIsActive(reducerFlowId),
  data: createFlowData(reducerFlowId),
  config: createFlowConfig(reducerFlowId),
  step: createStep(reducerFlowId),
  stoppedReason: createStoppedReason(reducerFlowId),
});

export default createFlowReducer;
